import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { RacecardRaceRouteType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import {
    CardFooterListItem,
    CardFooterListItemLink,
    ShowMoreArrowWrapper,
    ShowMoreLink,
    ShowMoreText,
} from 'src/domains/sportsbook/webview/components/racesSlider/shared/cardFooter/CardFooter.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { ViewAllIcon } from 'src/domains/casino/webview/CasinoGames/home-games/slider/slider-header/SliderHeader.style';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { BetGliderState } from 'src/domains/sportsbook/state/betGliderState/BetGliderState';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';

export interface CardFooterPropsType {
    routingData: RacecardRaceRouteType;
    race: EventModel;
}

export const CardFooter = observer('CardFooter', (props: CardFooterPropsType) => {
    const { routingData, race } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).unifiedComponentConfig;
    const breakpointsState = BreakpointsState.get(common);
    const betGliderState = BetGliderState.get(common);
    const starRouter = StarRouter.get(common);
    const { raceCardVariant } = configState.componentVariants;
    const isMobile = breakpointsState.tablet.isBiggerOrEq === false;
    const isRaceMapped = betGliderState.isRaceMapped(race.id2);

    const shouldRenderBetGliderLink =
        configState.isBetGliderActive && race.sport === 'horseracing' && isMobile && isRaceMapped;

    const handleBetGliderClick = (): void => {
        if (common.session.userId === null) {
            starRouter.redirectToLogin();
            return;
        }

        betGliderState.openBetGlider(race);
    };

    if (raceCardVariant === DefaultComponentVariantType.SECONDARY) {
        return (
            <CardFooterListItemLink to={routingData}>
                <ShowMoreText>
                    <I18n
                        langKey='events.racebox.view.label'
                        defaultText='View racecard'
                    />
                    <ViewAllIcon />
                </ShowMoreText>
            </CardFooterListItemLink>
        );
    }

    return (
        <CardFooterListItem>
            <ShowMoreLink to={routingData}>
                <I18n
                    langKey='events.racebox.view.label'
                    defaultText='View racecard'
                />
                <ShowMoreArrowWrapper position='right' />
            </ShowMoreLink>

            {shouldRenderBetGliderLink ? (
                <ShowMoreLink onClick={handleBetGliderClick}>
                    BetGlider
                    <ShowMoreArrowWrapper position='right' />
                </ShowMoreLink>
            ) : null}
        </CardFooterListItem>
    );
});
